// @flow
export const MARKETING_STATUS = Object.freeze({
  NA: 'NA',
  OPTED_IN: 'OPTED_IN',
  OPTED_OUT: 'OPTED_OUT'
});



// WEBPACK FOOTER //
// ./src/constants/suscriptionStatus.js